import CustomImage from './CustomImage';
import types from './types';
import variants from './variants';

export { types, variants };

export default CustomImage;
